import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { ZodSchema } from 'zod';

import { RegisterFormValues, registerSchema } from '../model/schema';

export const useRegisterForm = (schema: ZodSchema = registerSchema) => {
  return useForm<RegisterFormValues>({
    resolver: zodResolver(schema),
    mode: 'onChange',
    defaultValues: {
      email: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      company_website: '',
      monthly_revenue: '',
      job_title: '',
      agreed_to_terms: false
    }
  });
};
